export const centsToDisplay = (cents) => `$${(Math.max(0, cents || 0) / 100).toFixed(2)}`;

export const centsToInputValue = (cents) => ((cents || 0) / 100).toFixed(2);

export const dollarsInputToCents = (value) => {
  const n = parseFloat(value);
  if (Number.isNaN(n) || n < 0) return 0;
  return Math.round(n * 100);
};

export const BILLING_TYPE_LABELS = {
  recurring_monthly: "Recurring · Monthly",
  recurring_annual: "Recurring · Annual",
  one_time: "One-time",
};

export const computeQuoteTotals = (items = [], discount = {}, tax = {}) => {
  const recurringSubtotal = items.filter((i) => i.billing_type !== "one_time").reduce((s, i) => s + i.unit_price_cents * i.quantity, 0);
  const oneTimeSubtotal = items.filter((i) => i.billing_type === "one_time").reduce((s, i) => s + i.unit_price_cents * i.quantity, 0);

  const dType = discount?.type || "none";
  const appliesTo = discount?.applies_to || "both";
  let recurringDiscount = 0;
  let oneTimeDiscount = 0;
  if (dType === "percentage" && discount.percent) {
    const pct = discount.percent / 100;
    if (appliesTo === "recurring" || appliesTo === "both") recurringDiscount = Math.round(recurringSubtotal * pct);
    if (appliesTo === "one_time" || appliesTo === "both") oneTimeDiscount = Math.round(oneTimeSubtotal * pct);
  } else if (dType === "fixed" && discount.amount_cents) {
    const amount = discount.amount_cents;
    if (appliesTo === "recurring") {
      recurringDiscount = Math.min(amount, recurringSubtotal);
    } else if (appliesTo === "one_time") {
      oneTimeDiscount = Math.min(amount, oneTimeSubtotal);
    } else {
      const combined = recurringSubtotal + oneTimeSubtotal;
      const capped = Math.min(amount, combined);
      if (combined > 0) {
        recurringDiscount = Math.round((capped * recurringSubtotal) / combined);
        oneTimeDiscount = capped - recurringDiscount;
      }
    }
  }

  const recurringAfterDiscount = Math.max(0, recurringSubtotal - recurringDiscount);
  const oneTimeAfterDiscount = Math.max(0, oneTimeSubtotal - oneTimeDiscount);
  const taxRate = tax?.enabled ? (tax.rate_percent || 0) / 100 : 0;
  const recurringTax = Math.round(recurringAfterDiscount * taxRate);
  const oneTimeTax = Math.round(oneTimeAfterDiscount * taxRate);

  return {
    recurring_subtotal_cents: recurringSubtotal,
    one_time_subtotal_cents: oneTimeSubtotal,
    recurring_discount_cents: recurringDiscount,
    one_time_discount_cents: oneTimeDiscount,
    recurring_tax_cents: recurringTax,
    one_time_tax_cents: oneTimeTax,
    initial_total_cents: oneTimeAfterDiscount + oneTimeTax + recurringAfterDiscount + recurringTax,
    recurring_total_cents: recurringAfterDiscount + recurringTax,
  };
};
